import FormValidation from "../plugins/validate";
import Webinar from "./webinar";
import BaseForm from "./baseForm";
import getOffset from "../utils/getOffset";
import { load } from "recaptcha-v3";

export default class CoreEventRegistration extends Webinar {
    constructor() {
        super();
        this.formValidationQueryString = "[data-webinar-registration-form]";
        this.form = document.querySelector("[data-webinar-registration-form]");
        if (this.form) {
            this.fieldsValidateByApi = this.form.querySelectorAll("[data-api]");
            this.baseForm = new BaseForm(document.querySelector(".box-event-reg"));
            this.accessToken = null;
            this.registrationCheckController = null;
            this.init();
        }
    }

    onValidateForm() {
        const $this = this;
        if ($this.form) {
            new FormValidation({
                selector: this.formValidationQueryString,
                submitForm: false,
                invalidScroll: true,
                events: {
                    doSuccess() {
                        // Fallback: check for API-triggered invalid fields that don't go through plugin validation
                        const invalidFields = $this.form.querySelectorAll("input.invalid:not(:disabled), select.invalid:not(:disabled)");
                        if (invalidFields.length > 0) {
                            $this.navigateToInvalidFieldStep(invalidFields[0]);
                            return;
                        }
                        var recaptchaV3String = $("button[name='recaptcha']").val();
                        var recaptchaV3Boolean = recaptchaV3String === "true";
                        if (recaptchaV3Boolean) {
                            const recaptchaID = document.querySelector(".submit").dataset.sitekey;
                            load(recaptchaID).then(recaptcha => {
                                recaptcha.execute("submit").then(async token => {
                                    const winOrigin = window.location.origin;
                                    this.baseEndPtUrl = winOrigin;
                                    let url = this.baseEndPtUrl + "/.rest/webinarRecaptcha/";
                                    let data = "g-recaptcha-response=" + token;
                                    const response = await fetch(url, {
                                        method: "POST",
                                        cache: "no-cache",
                                        credentials: "same-origin",
                                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                                        redirect: "follow",
                                        referrerPolicy: "no-referrer",
                                        body: data
                                    });

                                    if (response.ok) {
                                        $this.onSubmitWebinar();
                                    }
                                    return false;
                                });
                            });
                        } else {
                            $this.onSubmitWebinar();
                        }
                    },
                    doError() {}
                }
            });
        }
    }

    navigateToInvalidFieldStep(invalidField) {
        if (!invalidField || !this.form) {
            return;
        }

        const allSteps = Array.from(this.form.querySelectorAll(".dupixent-form .item"));
        const targetStep = invalidField.closest(".dupixent-form .item");
        if (!targetStep) {
            return;
        }

        const targetStepIndex = allSteps.indexOf(targetStep);
        if (targetStepIndex === -1) {
            return;
        }

        const scrollTarget = invalidField.closest(".form-group") || invalidField;
        const activeStepIndex = this.getActiveStepIndex();

        if (targetStepIndex !== activeStepIndex) {
            $(this.form).one("slid.bs.carousel", () => {
                this.updateAnsweredState(targetStepIndex);
                this.updateStepControls(targetStepIndex);
                window.scrollTo({
                    top: getOffset(scrollTarget),
                    behavior: "smooth"
                });
            });
            $(this.form).carousel(targetStepIndex);
            return;
        }

        this.updateAnsweredState(targetStepIndex);
        this.updateStepControls(targetStepIndex);
        window.scrollTo({
            top: getOffset(scrollTarget),
            behavior: "smooth"
        });
    }

    getActiveStepIndex() {
        const steps = this.form.querySelectorAll(".dupixent-form .item");
        return Array.from(steps).findIndex(step => step.classList.contains("active"));
    }

    updateAnsweredState(activeStepIndex) {
        const steps = this.form.querySelectorAll(".dupixent-form .item");
        const indicators = this.form.querySelectorAll(".carousel-indicators li");

        steps.forEach((step, index) => {
            step.classList.toggle("answered", index < activeStepIndex);
        });

        indicators.forEach((indicator, index) => {
            indicator.classList.toggle("answered", index < activeStepIndex);
            indicator.setAttribute("aria-current", index === activeStepIndex ? "true" : "false");
        });
    }

    updateStepControls(activeStepIndex) {
        const totalSteps = this.form.querySelectorAll(".dupixent-form .item").length;
        const isFirstStep = activeStepIndex <= 0;
        const isLastStep = activeStepIndex >= totalSteps - 1;

        this.next.classList.toggle("hidden", isLastStep);
        this.submit.classList.toggle("hidden", !isLastStep);
        this.prev.classList.toggle("invisible", isFirstStep);
    }

    onClickNext() {
        this.next.addEventListener("click", () => {
            const currentStepGroup = this.form.querySelector(".dupixent-form .item.active");

            const existError = currentStepGroup.getElementsByClassName("invalid");
            if (existError.length > 0) {
                return;
            }

            const activeStepIndex = this.getActiveStepIndex();
            const totalSteps = this.form.querySelectorAll(".dupixent-form .item").length;
            if (activeStepIndex < totalSteps - 1) {
                const targetStepIndex = activeStepIndex + 1;
                $(this.form).one("slid.bs.carousel", () => {
                    this.updateAnsweredState(targetStepIndex);
                    this.updateStepControls(targetStepIndex);
                });
                $(this.form).carousel("next");
            }
        });
    }

    onClickPrev() {
        this.prev.addEventListener("click", () => {
            const activeStepIndex = this.getActiveStepIndex();
            if (activeStepIndex > 0) {
                const targetStepIndex = activeStepIndex - 1;
                $(this.form).one("slid.bs.carousel", () => {
                    this.updateAnsweredState(targetStepIndex);
                    this.updateStepControls(targetStepIndex);
                });
                $(this.form).carousel("prev");
            }
        });
    }

    onPhoneOptionChange() {
        const textOptionElement = this.form.querySelector("#text-option");
        const phoneOptionElement = this.form.querySelector("#phone-option");
        const phoneNumberOptionElement = this.form.querySelector("#phone-number-option");
        const phoneNumberInputElement = this.form.querySelector("#phone-number");
        const smsConsentElement = this.form.querySelector("#text-consent");
        if (!textOptionElement || !phoneOptionElement || !phoneNumberOptionElement || !phoneNumberInputElement) {
            return;
        }

        const syncPluginValidationState = el => {
            if (!el) return;
            // Force validate.js to recompute its internal error arrays after dynamic required/disabled changes.
            el.dispatchEvent(new Event("change", { bubbles: true }));
        };

        const setPhoneSectionDisabled = disabled => {
            phoneNumberInputElement.disabled = disabled;
            phoneNumberInputElement.required = !disabled;
            if (smsConsentElement) smsConsentElement.disabled = disabled;
            if (disabled) {
                phoneNumberInputElement.value = "";
                if (smsConsentElement) {
                    smsConsentElement.checked = false;
                    smsConsentElement.required = false;
                }
            }
        };

        const updatePhoneSectionState = () => {
            const shouldShowPhoneSection = textOptionElement.checked || phoneOptionElement.checked;
            phoneNumberOptionElement.classList.toggle("hidden", !shouldShowPhoneSection);
            setPhoneSectionDisabled(!shouldShowPhoneSection);

            if (smsConsentElement) {
                smsConsentElement.required = textOptionElement.checked;
                if (!textOptionElement.checked && shouldShowPhoneSection) {
                    smsConsentElement.checked = false;
                }
            }

            // Only sync validate.js when rules are relaxed to clear stale plugin errors.
            if (!shouldShowPhoneSection) {
                syncPluginValidationState(phoneNumberInputElement);
                syncPluginValidationState(smsConsentElement);
            } else if (!textOptionElement.checked) {
                syncPluginValidationState(smsConsentElement);
            }
        };

        textOptionElement.addEventListener("change", e => {
            e.preventDefault();
            updatePhoneSectionState();
        });

        phoneOptionElement.addEventListener("change", e => {
            e.preventDefault();
            updatePhoneSectionState();
        });

        updatePhoneSectionState();
    }

    onMarketingChange() {
        const marketingOptElement = this.form.querySelector("#marketing");
        const termsElement = this.form.querySelector("#terms");
        if (!marketingOptElement || !termsElement) {
            return;
        }

        marketingOptElement.addEventListener("change", e => {
            e.preventDefault();
            if (e.target.checked) {
                termsElement.classList.remove("hidden");
            } else {
                termsElement.classList.add("hidden");
            }
        });
    }

    async onSubmitWebinar() {
        const boxEventRegister = document.querySelector(".box-event-reg");
        if (boxEventRegister) {
            boxEventRegister.classList.add("loading");
        }

        if (!this.eventId) {
            return;
        }

        if (!this.accessToken) {
            this.accessToken = await this.getAccessToken();
        }

        if (!this.accessToken) {
            return;
        }

        const body = this.baseForm.serializeFormData();

        const url = this.eventsApi + "rsvps";
        const headers = this.getDefaultHeaderContentUrlencoded();

        return fetch(url, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: headers,
            redirect: "follow",
            referrerPolicy: "no-referrer",
            body: body
        })
            .then(response => response.json())
            .then(res => {
                this.handleRegisterResult(res);
                return boxEventRegister.classList.remove("loading");
            })
            .catch(error => {
                console.error(error.message); // eslint-disable-line
                return boxEventRegister.classList.remove("loading");
            });
    }

    isInvalidRsvpButSuccess(res) {
        return res.Meta?.Message === "invalid rsvp." && res.Meta?.StatusCode === 400 && res.Result?.Message === "invalid rsvp." && res.Result?.ExceptionMessage === "invalid rsvp.";
    }

    handleRegisterResult(res) {
        try {
            this.form.classList.add("hidden");
            if (res.Result.Success || this.isInvalidRsvpButSuccess(res)) {
                const registerSuccessElement = document.querySelector(".register-success");
                window.scrollTo({
                    top: getOffset(registerSuccessElement),
                    behavior: "smooth"
                });
                registerSuccessElement.classList.remove("hidden");
            } else if (res.Result.WaitList) {
                const waitListSuccessElement = document.querySelector(".waitlist-success");
                window.scrollTo({
                    top: getOffset(waitListSuccessElement),
                    behavior: "smooth"
                });
                waitListSuccessElement.classList.remove("hidden");
            }
        } catch (e) {
            console.error(e.message); // eslint-disable-line
            return;
        }
    }

    async runRegistrationCheck(emailAddress) {
        if (this.registrationCheckController) {
            this.registrationCheckController.abort();
        }
        this.registrationCheckController = new AbortController();
        const { signal } = this.registrationCheckController;
        console.log("[runRegistrationCheck] checking registration for:", emailAddress.value); // eslint-disable-line
        if (!this.accessToken) {
            this.accessToken = await this.getAccessToken();
        }
        if (signal.aborted) return false;
        if (!this.accessToken) return true;
        const isEmailRegistered = await this.isEmailRegistered(emailAddress.value, signal);
        if (isEmailRegistered === null) return false;
        console.log("[runRegistrationCheck] isRegistered:", isEmailRegistered); // eslint-disable-line
        this.handleEmailRegisteredValidation(emailAddress, isEmailRegistered);
        return true;
    }

    isEmailRegistered(emailAddress, signal) {
        if (!this.accessToken || !this.eventId || !emailAddress?.length) {
            return false;
        }

        const url = this.eventsApi + "events/" + this.eventId + "/rsvps/" + emailAddress;
        const headers = this.getDefaultHeaderContentJson();
        return fetch(url, {
            method: "POST",
            signal,
            cache: "no-cache",
            credentials: "same-origin",
            headers: headers,
            redirect: "follow",
            referrerPolicy: "no-referrer"
        })
            .then(response => response.json())
            .then(data => data.isRegistered)
            .catch(error => {
                if (error.name === "AbortError") return null;
                console.error(error.message); // eslint-disable-line
                return false;
            });
    }

    handleEmailRegisteredValidation(emailAddress, isEmailRegistered) {
        if (emailAddress.classList.contains("invalid")) {
            return;
        }
        if (isEmailRegistered) {
            const dataValidateId = emailAddress.getAttribute("data-validate-id");
            const errEmailElm = '<div id="' + dataValidateId + '" class="error error-container">This email address is already registered for this event.</div>';
            if (emailAddress.parentElement.querySelector(".error")) {
                emailAddress.parentElement.querySelector(".error").remove();
            }
            emailAddress.classList.remove("success");
            emailAddress.classList.add("invalid");
            emailAddress.parentElement.insertAdjacentHTML("beforeend", errEmailElm);
        } else if (emailAddress.parentElement.querySelector(".error")) {
            emailAddress.classList.remove("invalid");
            emailAddress.parentElement.querySelector(".error").remove();
        }
    }

    init() {
        if (!this.form) {
            return;
        }

        const dataEventId = this.form.querySelector("[data-event-id]");
        if (dataEventId) {
            dataEventId.value = this.eventId;
        }

        this.baseForm.onValidateByApi();
        this.prev = this.form.querySelector(".prev");
        this.next = this.form.querySelector(".next");
        this.submit = this.form.querySelector(".submit");
        this.updateAnsweredState(this.getActiveStepIndex());
        this.updateStepControls(this.getActiveStepIndex());

        this.pendingApiValidations = new Set();
        const emailAddress = this.form.querySelector("#email-address");
        this.form.querySelectorAll(".item.active [data-api]").forEach(input => {
            input.addEventListener("blur", () => {
                if (!input.value || !input.validity.valid) return;
                this.pendingApiValidations.add(input);
            });
            input.addEventListener("apivalidated", async () => {
                this.pendingApiValidations.delete(input);
                if (input === emailAddress && !input.classList.contains("invalid") && !localStorage.getItem("noSafeToSend")) {
                    input.classList.add("validating");
                    this.pendingApiValidations.add(input);
                    const completed = await this.runRegistrationCheck(input);
                    if (completed) {
                        input.classList.remove("validating");
                        this.pendingApiValidations.delete(input);
                    }
                }
            });
        });

        this.phoneNumberInputElement = this.form.querySelector("#phone-number");
        this.phoneNumberInputElement.disabled = true;
        const initialSmsConsent = this.form.querySelector("#text-consent");
        if (initialSmsConsent) initialSmsConsent.disabled = true;

        const recaptchaID = this.form.querySelector(".submit")?.dataset.sitekey;
        if (recaptchaID) load(recaptchaID);

        this.onValidateForm();

        this.onClickNext();
        this.onClickPrev();
        this.onPhoneOptionChange();
        this.onMarketingChange();
    }
}
